import React, { useRef, useMemo } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';

const SinusParticleField: React.FC<{ count?: number }> = ({ count = 2000 }) => {
    const pointsRef = useRef<THREE.Points>(null!);
    const positions = useMemo(() => {
        const arr = new Float32Array(count * 3);
        for (let i = 0; i < count; i++) {
            arr[i * 3] = (Math.random() - 0.5) * 20;
            arr[i * 3 + 1] = (Math.random() - 0.5) * 12;
            arr[i * 3 + 2] = (Math.random() - 0.5) * 5;
        }
        return arr;
    }, [count]);

    useFrame(({ clock }) => {
        const t = clock.getElapsedTime();
        const attr = pointsRef.current.geometry.attributes.position;
        for (let i = 0; i < count; i++) {
            const x = attr.array[i * 3];
            attr.array[i * 3 + 1] = Math.sin(t + x * 0.5) * 2;
        }
        attr.needsUpdate = true;
    });

    return (
        <points ref={pointsRef}>
            <bufferGeometry>
                <bufferAttribute attach="attributes-position" args={[positions, 3]} />
            </bufferGeometry>
            <pointsMaterial color={0xffffff} size={0.05} sizeAttenuation={false} />
        </points>
    );
};

export default SinusParticleField;